import React from 'react';

const Footer = () => {
  return (
    <footer>
      <span className="footerText">SaveForLater is an experiment atm <span role="img" aria-label="emoji">🔬</span></span>
    </footer>
  );
};

export default Footer;